module.exports = __webpack_public_path__ + "128bc856102acd7689814f097f433ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/BeerCard/images/draught-exclusive.png
// module id = SMKk
// module chunks = 0